/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from 'react';
import { CarouselProvider, Slider, Slide, CarouselContext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { StyledSearchMiniCardSlider } from './SearchMiniCardSlider.styles';
import { SearchOutletMiniCard } from '../SearchOutletMiniCard';
import { miniCardHeight, miniCardWidth } from '../../../modules/utils/constants/constants';

const ActiveSlideTracker = (props: any) => {
  const carouselContext = useContext(CarouselContext);

  useEffect(() => {
    if (!carouselContext) return;
    const onSlideChange = () => {
      const index = props?.isMobileView
        ? Math.ceil(carouselContext.state.currentSlide) === props?.outletLength - 1
          ? Math.ceil(carouselContext.state.currentSlide)
          : carouselContext.state.currentSlide
        : 0;
      props?.setCurrentSlide(index);
    };
    carouselContext.subscribe(onSlideChange);
    return () => carouselContext.unsubscribe(onSlideChange);
  }, [carouselContext, props?.setCurrentSlide]);

  return null;
};

export const SearchMiniCardSlider = (props: any) => {
  const [currentSlide, setCurrentSlide] = useState(props?.isMobileView ? props?.activeMarker : 0);
  const [visibleSlides, setVisibleSlides] = useState(1);

  useEffect(() => {
    if (props?.isMobileView) {
      props?.setActiveMarker(currentSlide);
      props?.handleOutletSelection(currentSlide);
    }
  }, [currentSlide]);

  useEffect(() => {
    const slides = Math.max((props?.containerWidth - 32) / 340, 1);
    setVisibleSlides(slides);
  }, [props?.containerWidth]);

  return (
    <StyledSearchMiniCardSlider className="px-3" containerWidth={props?.containerWidth}>
      <div className="d-flex flex-column carousel-container mx-3">
        <CarouselProvider
          naturalSlideWidth={miniCardWidth}
          naturalSlideHeight={miniCardHeight}
          totalSlides={props?.searchResults?.length}
          visibleSlides={visibleSlides}
          currentSlide={currentSlide}
          isIntrinsicHeight={true}
          infinite={true}
        >
          <ActiveSlideTracker
            setCurrentSlide={setCurrentSlide}
            outletLength={props?.searchResults?.length}
            isMobileView={props?.isMobileView}
          />
          <Slider className="carousel-slider">
            {props?.searchResults?.map((outlet: any, index: number) => (
              <Slide index={index} key={index}>
                <div className="slide-container d-flex align-items-center justify-content-center">
                  <SearchOutletMiniCard outlet={outlet} {...props} />
                </div>
              </Slide>
            ))}
          </Slider>
        </CarouselProvider>
      </div>
    </StyledSearchMiniCardSlider>
  );
};
